import { createFileRoute } from '@tanstack/react-router'

import { itemCategoryApi } from '@/features/inventory/api/item-category-api'
import { ItemCategoryFormPage } from '@/features/inventory/components/item-category-form-page'

export const Route = createFileRoute('/_app/inventory/category/update/$id')({
  loader: async ({ params, context }) => {
    const { id } = params
    const { data } = await context.qc.ensureQueryData(
      itemCategoryApi.detail.query({ params: { id } })
    )
    return {
      crumb: data.category.name,
    }
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { id } = Route.useParams()
  return <ItemCategoryFormPage mode='update' id={id} />
}
